import { render, staticRenderFns } from "./movementCreate.vue?vue&type=template&id=3397be9f&"
import script from "./movementCreate.vue?vue&type=script&lang=js&"
export * from "./movementCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports